import React from "react";

const MiniCard = ({ icon, value, label, color = "green" }) => {
  return (
    <div className={`mini-card ${color}`}>
      <div className="mini-icon">{icon}</div>
      <div>
        <h2 className="mini-value">{value}</h2>
        <p className="mini-label">{label}</p>
      </div>
    </div>
  );
};

export default MiniCard;
